import { useQuery } from "graphql-hooks";
import { Helmet } from "react-helmet";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import { clientConfig } from "../../utilities/configService";
import { useAPIErrorContext } from '../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
  websiteConfiguration {
    fieldPreFooterText
    fieldFooterImage {
      alt
      filename
      url
    }
    fieldFooterContent
  }
}`;

declare var lhnJsSdk: any;

export const Footer = () => {
    const navigate = useNavigate();
    const { loading, error, data } = useQuery(CMS_QUERY, {
        variables: {
            limit: 10
        }
    });
    const { trackError } = useAPIErrorContext();

    if (!error && !loading) {
        return (
            <>
                {clientConfig && clientConfig?.CHAT_ENABLED ? (
                    <Helmet>
                        <script type="text/javascript">
                            {
                                ` window.lhnJsSdkInit = function () {
                             lhnJsSdk.setup = {
                                 application_id: "11f4f5c7-9f87-4edc-99e3-5e6d4fabb48b",
                                 application_secret: "b74d795228334320abaebca7fca329cdbba0343b5dd04c32b7"
                             };
                             lhnJsSdk.controls = [{
                                 type: "hoc",
                                 id: "fdea94fe-efc2-4e34-9ac1-5ce241ed7446"
		                     }];
	                    };

                        (function (d, s) {
		                    var newjs, lhnjs = d.getElementsByTagName(s)[0];
                            newjs = d.createElement(s);
                            newjs.src = "https://developer.livehelpnow.net/js/sdk/lhn-jssdk-current.min.js";
                            lhnjs.parentNode.insertBefore(newjs, lhnjs);
	                    }(document, "script"));`
                            }

                        </script>
                    </Helmet>
                ) : ('')}
                <footer className="container-fluid footer">
                    {clientConfig && clientConfig?.CHAT_ENABLED ? (
                        <Row className="actionBodyRow">
                            <Col className='phoneButtonColumn'>
                                <Row className="heading5">
                                    <Col><div className="footerPhoneText" dangerouslySetInnerHTML={{ __html: data.websiteConfiguration.fieldPreFooterText }}></div></Col>
                                    <Col className="footerPhoneButton">
                                        <Button className="solidNeg primaryButton iconRightArrow text-nowrap" onClick={() => { navigate('/ContactUs') }}>Contact Us</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="chatButtonColumn">
                                <Row className="heading5">
                                    <Col><div className="footerPhoneText">Questions?&nbsp;&nbsp;</div></Col>
                                    <Col><Button className="submitButton solidNeg primaryButton iconChat" onClick={() => { lhnJsSdk.openHOC(); return false; }}>Live Chat</Button></Col>
                                </Row>
                            </Col>
                        </Row>
                    ) : (
                        <Row className="actionBodyRow">
                            <Col className='text-center' >
                                <Row className="heading5">
                                    <Col className="footerPhoneButton">
                                        <div className="footerPhoneText inlineText" dangerouslySetInnerHTML={{ __html: data.websiteConfiguration.fieldPreFooterText }}></div>
                                        <Button className="solidNeg primaryButton iconRightArrow text-nowrap" onClick={() => { navigate('/ContactUs') }}>Contact Us</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}

                    <Row className="copyFooterBody">
                        <div className="footerPageBodyRow">
                            <Row>
                                <Col sm={2} className="footerLogoColumn">
                                    <img src={data.websiteConfiguration.fieldFooterImage.url} className="footerLogo" alt="ICF" />
                                </Col>
                                <Col className="copyFooterRight">
                                    <Row className="linkList">
                                        {clientConfig?.CONTENT.FOOTER_LINKS.map((link, index) => {
                                            return (
                                                <Col sm="auto" className="col" key={index}>
                                                    <Link to={link.URL} target="_blank">
                                                        {link.TITLE}
                                                    </Link>
                                                </Col>
                                            )})}
                                        <Col sm="auto" className="col">
                                            <NavLink to="/ContactUs">
                                                <span>Contact Us</span>
                                            </NavLink>
                                        </Col>
                                        <Col sm="auto" className="col">
                                            <NavLink to="/PrivacyStatement">
                                                Privacy Statement
                                            </NavLink>
                                        </Col>
                                        <Col sm="auto" className="col">
                                            <NavLink to="/TermsOfUse">
                                                Terms of Use
                                            </NavLink>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </div>
                    </Row>
                </footer>
            </>);
    }
    else {
        if (error && !loading) {
            trackError("Dato error", JSON.stringify(error));
        }
        return (
            <footer className="container-fluid footer">
                <Row className="copyFooterBody">
                    <div className="footerPageBodyRow">
                        <Row>
                            <Col sm={12} className="footerLogoColumn">
                                <p>&nbsp;</p>
                            </Col>
                        </Row>
                    </div>
                </Row>
            </footer>
        );
    }

};
